import Plyr from 'plyr';
const init = () => {
    const videos = document.querySelectorAll('video, [data-type="youtube"], [data-type="vimeo"]');
    window.players = window.players || []; // Initialize the players array
    videos.forEach((video) => {
        const shouldAutoplay = video.hasAttribute('autoplay');
        const hasNoControls = video.classList.contains('no-controls'); // Check for 'no-controls' class
        const plyrElement = video; // Cast video to HTMLVideoElement or HTMLElement
        const player = new Plyr(plyrElement, {
            autoplay: shouldAutoplay,
            loop: { active: shouldAutoplay },
            controls: hasNoControls ? [] : (shouldAutoplay ? [] : ['play', 'play-large', 'progress', 'mute', 'volume', 'duration']),
            clickToPlay: !hasNoControls && !shouldAutoplay,
            fullscreen: {
                enabled: !shouldAutoplay && !hasNoControls,
                fallback: true,
                iosNative: false,
                container: null
            }
        });
        if (shouldAutoplay) {
            player.muted = true;
            player.volume = 0;
            video.removeAttribute('controls');
            player.play();
        }
        else {
            player.muted = false;
            player.volume = 1;
        }
        window.players.push(player); // Store the player instance
    });
};
export { init };
